<template>
    <div class="card">
        <loading :active.sync="retrieveListLoading" 
            :can-cancel="true"
            :is-full-page="false">
        </loading>
        <div class="card-header user-title">
            <h3>Kakao Authority List</h3>
        </div>
        <div class="card-body">
            <div class="d-flex">
                <button type="button" class="btn btn-green flex-grow-0" v-on:click="showKakaoAuthorityPopup()">Kakao Authority 생성</button>
            </div>
            <table class="table table-hover table-striped table-light table-bordered mt-2 shadow-sm">
                <thead class="">
                    <tr class="text-center device-table-header">
                        <th>Authority ID</th>
                        <th>Authority Name</th>
                        <th>Description</th>
                        <th>Detail</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="kakaoAuthority in kakaoAuthorityList">
                        <td>{{ kakaoAuthority.authorityId }}</td>
                        <td>{{ kakaoAuthority.authorityName }}</td>
                        <td>{{ kakaoAuthority.description }}</td>
                        <td class="text-center">
                            <button type="button" class="btn btn-blue" @click="showKakaoAuthorityPopup(kakaoAuthority)">Detail</button>
                        </td>
                    </tr>
                    <tr v-show="kakaoAuthorityList.length == 0">
                        <td class="text-center" colspan="4">결과가 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="text-center">
                <button class="btn btn-view-more" v-bind:style="{width:'40%'}" v-on:click="seeMore()" :disabled="kakaoAuthorityList.length == total">더보기 ({{ kakaoAuthorityList.length }} / {{ total }})</button>
            </div>
        </div>
        <!--card-body-->
    
        <!--Detail modal start-->
        <b-modal size="lg" ref="requestModal" header-class="detail-header" title="Kakao User Information" ok-only ok-variant="secondary" ok-title="Close"> <!-- size = xl, lg, sm -->
            <loading :active.sync="requestLoading" 
                :can-cancel="false" 
                :is-full-page="false"></loading>
            <table class="table table-striped table-bordered table-hover shadow-sm mt-2">
                <tbody>
                    <tr>
                        <td>Authority ID *</td>
                        <td>
                            <div class="form-group mr-2 flex-grow-1">
                                <input class="form-control" placeholder="Authority ID" name="authorityId" v-model= "kakaoAuthority.authorityId" v-validate="'required'" :disabled="existentFlag">         
                                <div class="alert-danger" v-if="submitted && errors.has('authorityId')">{{ errors.first('authorityId') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Authority Name *</td>
                        <td>
                            <div class="form-group mr-2 flex-grow-1">
                                <input class="form-control" placeholder="Authority Name" name="authorityName" v-model= "kakaoAuthority.authorityName" v-validate="'required'" :disabled="existentFlag">         
                                <div class="alert-danger" v-if="submitted && errors.has('authorityName')">{{ errors.first('authorityName') }}</div>
                            </div>
                        </td>
                    </tr>
                    <!-- <tr v-if="existentFlag"> -->
                    <tr>
                        <td>Description</td>
                        <td>
                            <div class="form-group mr-2 flex-grow-1">
                                <input class="form-control" maxlength="256" placeholder="description" name="description" v-model="kakaoAuthority.description"/>
                                <div class="alert-danger" v-if="submitted && errors.has('description')">{{ errors.first('description') }}</div>
                            </div>
                        </td>
                    </tr>
                    <!-- <tr v-if="existentFlag">
                        <td>Status *</td>
                        <td>
                            <div class="form-group mr-2 flex-grow-1">
                                <b-form-select v-model="kakaoUser.status" :options="statusOptions" size="" v-validate="'required'" name="status">
                                </b-form-select>
                                <div class="alert-danger" v-if="submitted && errors.has('status')">{{ errors.first('status') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Email (1)</td>
                        <td>
                            <div class="form-group mr-2 flex-grow-1">
                                <input type="email" class="form-control" placeholder="gildong.hong@kr.ey.com" name="email" v-model="kakaoUser.email" v-validate="'required'"/>
                                <div class="alert-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Email (2)</td>
                        <td>
                            <div class="form-group mr-2 flex-grow-1">
                                <input type="email" class="form-control" placeholder="gildong.hong@kr.ey.com" name="subEmail" v-model="kakaoUser.subEmail" v-validate="'required'"/>
                                <div class="alert-danger" v-if="submitted && errors.has('subEmail')">{{ errors.first('subEmail') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="existentFlag && kakaoUser.status == 'registering'" >
                        <td>Passcode</td>
                        <td>
                            <div class="form-group mr-2 flex-grow-1">
                                <input class="form-control" placeholder="" name="passcode" v-model="kakaoUser.passcode" v-validate="''" disabled/>
                                <div class="alert-danger" v-if="submitted && errors.has('passcode')">{{ errors.first('passcode') }}</div>
                            </div>
                        </td>
                    </tr>            -->
                </tbody>
            </table>
            <div class="text-center pb-2" style="display: inline-block; float: right;" >
                <button type="button" class="btn btn-green" v-on:click="requestKakaoAuthority()">{{ existentFlag ? 'Update' : 'Submit' }}</button>
                <button v-show="!existentFlag" type="button" class="btn btn-red" style="margin-left: 10px;" v-on:click="resetRequestForm()">Reset</button>
                <button v-show="existentFlag" type="button" class="btn btn-red" style="margin-left: 10px;" v-on:click="deleteKakaoAuthority()">Delete</button>
            </div>
        </b-modal>
        <!--Detail modal end -->
    
        <!--Message Modal-->
        <b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary" ok-title="Close">
            <p class="my-4 text-center">{{ msgContent }}</p>
        </b-modal>   
    
    </div><!--card-->
    </template>
    
    <script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    
    export default {
        name: 'KakaoAuthority',
        data() {
            return {        
                kakaoAuthorityList: [],  // retrieveKakaoUserList의 결과
                total: 0,  // 이 화면의 검색 조건에 맞는 WorkMan에 있는 KakaoUser 총 개수
                limit: 0,
                offset: 0,
                PAGE_LIMIT : 10,
    
                existentFlag: false,  // 이미 있는 Kakao User 여부 (있으면 수정/삭제가 가능, 없으면 신규 요청이 가능)
                // 신청(updateKakaoUser) 팝업에서 사용
                authorityId: '',
                authorityName: '',
                description: '',
                kakaoAuthority: {}, //authority raw데이터
                // statusOptions: [
                //     { value: 'registering', text: '신청중' },
                //     { value: 'available', text: '승인완료' },
                //     { value: 'inactive', text: '일시중지' }
                // ],
                // statusMap: {
                //     'registering' : '신청중',
                //     'available' : '승인완료',
                //     'inactive' : '일시중지',
                // },
    
                submitted: false,  // true가 되면 validate 를 진행함
                retrieveListLoading: false,  // Kakao User 리스트를 보여주는 곳의 로딩바
                requestLoading: false,  // Kakao User 신청 폼에서 보여주는 로딩바
    
                msgStatus: '',  // alert popup 의 status 인데 사용하진 않고, 아래 content는 보여줌
                msgContent: ''
            }
        },
        components: {
            Loading
        },
        computed: {
        },
        methods: {
            showMessage(status, message) {
                this.msgStatus = status;
                this.msgContent = message;
                
                this.$bvModal.show('messageModal');
            },
            showKakaoAuthorityPopup(kakaoAuthority) {
                this.existentFlag = false;
                this.resetRequestForm();
    
                if (kakaoAuthority != null) {
                    this.requestLoading = true;
    
                    var params = {
                        'authorityId': kakaoAuthority.authorityId.trim(),
                        'authorityName': kakaoAuthority.authorityName.trim()
                    };
    
                    axios.get('peon/retrieveKakaoAuthority', {
                        params: params,
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': accessToken()
                        }
                    }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                        if(response.data.body == null) {
                            this.showMessage(-1, "wrong information");
                            return;
                        }
                        this.kakaoAuthority = response.data.body;          
                        this.existentFlag = true;
                    }).catch(error => {
                        if (error.status != 401) {
                            this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                        }
                    }).finally(() => {
                        this.requestLoading = false;
                    });
                } else {
                    this.resetRequestForm();
                }
    
                this.$refs['requestModal'].show();
            },
            resetRequestForm() {
                this.kakaoAuthority = {};
                this.kakaoAuthority.authorityId = this.authorityId;
                this.kakaoAuthority.authorityName = this.authorityName;
            },
            seeMore() {
                if (this.kakaoAuthorityList && this.kakaoAuthorityList.length > 0) {
                    this.offset = this.offset + this.limit;
                }
    
                this.retrieveKakaoAuthorityList();
            },
            reloadRetrieveKakaoAuthorityList() {
                // 재조회를 위한 값
                this.offset = 0;
                this.limit = (this.kakaoAuthorityList.length % this.PAGE_LIMIT === 0 ? parseInt(this.kakaoAuthorityList.length / this.PAGE_LIMIT) : parseInt(this.kakaoAuthorityList.length / this.PAGE_LIMIT) + 1) * this.PAGE_LIMIT;
                this.kakaoAuthorityList = [];
    
                this.retrieveKakaoAuthorityList();
    
                // 원래값
                this.offset = this.limit - this.PAGE_LIMIT;
                this.limit = this.PAGE_LIMIT;
            },
            retrieveKakaoAuthorityList() {            
                this.retrieveListLoading = true;
               
                var params = {
                    'offset': this.offset,
                    'limit': this.limit
                };
    
                axios.post('peon/retrieveKakaoAuthorityList', params, {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': accessToken()
                    }
                }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                    response.data.body.list.forEach((item, index, array) => {
                        this.kakaoAuthorityList.push(item);
                    });
    
                    this.total = response.data.body.total;
                    this.authorityId = response.data.body.authorityId;
                    this.authorityName = response.data.body.authorityName;
                }).catch(error => {
                    if (error.status != 401) {
                        this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                    }
                }).finally(() => {
                    this.retrieveListLoading = false;
                });           
            },
            requestKakaoAuthority() {
                this.submitted = true;
    
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.requestLoading = true;
    
                        var UPDATE_URL = 'upsertKakaoAuthority';
    
                        // if (!this.existentFlag) {
                        //     this.kakaoUser.status = 'registering';
                        //     // UPDATE_URL = 'updateKakaoUser'
                        // }
    
                        axios.post('peon/' + UPDATE_URL, this.kakaoAuthority, {
                            headers: {
                                'Accept': 'application/json',
                                'Authorization': accessToken()
                            }
                        }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                            this.submitted = false;
    
                            this.reloadRetrieveKakaoAuthorityList();
    
                            this.$refs['requestModal'].hide();
    
                            this.showMessage(0, "권한 " + (this.existentFlag ? "수정이" : "추가가") + " 완료되었습니다.");
                        }).catch(error => {
                            if (error.status != 401) {
                                this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                            }
                        }).finally(() => {
                            this.requestLoading = false;
                            this.submitted = false;
                        });
                    }
                });
            },
            deleteKakaoAuthority() {
                this.requestLoading = true;
               
                var params = {
                    'authorityId': this.kakaoAuthority.authorityId.trim(),
                    'authorityName': this.kakaoAuthority.authorityName.trim()
                };
    
                axios.get('peon/deleteKakaoAuthority', {
                    params: params,
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': accessToken()
                    }
                }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                    this.reloadRetrieveKakaoAuthorityList();
    +
                    this.$refs['requestModal'].hide();
    
                    this.showMessage(0, "사용자 삭제가 완료되었습니다.");
                }).catch(error => {
                    if (error.status != 401) {
                        this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                    }
                }).finally(() => {
                    this.requestLoading = false;
                });
            }
        },
        created() {
            this.limit = this.PAGE_LIMIT;
            this.retrieveKakaoAuthorityList();
        }
    }
    </script>
    
    <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>
    </style>
    